import { render, staticRenderFns } from "./Configurazione.vue?vue&type=template&id=70b0b2d4&scoped=true"
import script from "./Configurazione.vue?vue&type=script&lang=js"
export * from "./Configurazione.vue?vue&type=script&lang=js"
import style0 from "./Configurazione.vue?vue&type=style&index=0&id=70b0b2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b0b2d4",
  null
  
)

export default component.exports